<div class="chart-wrapper">
  <svg name="axis" class="chart axis" shape-rendering="optimizeSpeed"></svg>
  <div class="scroll-gradient">
    <div name="detailsScroll" class="details-scroll">
      <svg name="details" class="chart details" shape-rendering="optimizeSpeed"></svg>
    </div>
  </div>
</div>
<div class="chart-key">
  @for (k of keys(); track k.key) {
    <div class="key {{ k.key }}">
      {{ k.label }}
    </div>
  }
</div>
